import type { ToolId } from '../types/tools';

export const toolGroups: {id: ToolId;label: string;}[][] = [
[{ id: 'oneclick', label: '1-Click' }],
[
{ id: 'size', label: 'Size' },
{ id: 'protect', label: 'Protect' },
{ id: 'orient', label: 'Orient' },
{ id: 'support', label: 'Support' },
{ id: 'layout', label: 'Layout' }],

[
{ id: 'hollow', label: 'Hollow' },
{ id: 'texture', label: 'Texture' },
{ id: 'label', label: 'Label' },
{ id: 'hole', label: 'Hole' }]];
